<template>
    <div class="language">
        <el-dropdown trigger="click" @command="changeLanguage">
            <span class="lang">
                <span v-text="currentLanguage"></span>
                <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item, index) in list" :key="index" :command='item'>{{item.label}}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>


<script>
    import list from '@/language/languageList'

    export default {
        name: 'language',           /* 多语言切换 */
        data() {
            return {
                currentLanguage: '',
                list: [],
            }
        },
        created() {
            this.currentLanguage = localStorage.langName || '简体中文';
            this.list = list;
        },
        methods: {
            changeLanguage(item) {
                this.currentLanguage = item.label;
                this.$i18n.locale = item.value;
                localStorage.setItem('langName', item.label);
                localStorage.setItem('lang', item.value);
            },
        },
    }
</script>


<style lang="scss" scoped>
    .lang{
        display: flex;
        width: 76px;
        height: 20px;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: white;
        border: 1px solid black;
    }
    .lang span{
        font-size: 12px;
    }
    .el-dropdown-menu{
        width: 66px;
        list-style-type: none;
        background: black;
        border-radius: 5%;
        border: 1px solid #46485f;
        padding: 5px;
    }
    .el-dropdown-menu__item{
        color: white;
        text-align: center;
        border: 1px solid whitesmoke;
        cursor: pointer;
        padding: 0;
        height: 20px;
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .el-dropdown-menu__item:not(.is-disabled):hover{
        color: black;
        background-color: white;
    }
</style>
